export default __webpack_public_path__ + "static/media/lightSwapCard.d416d7a8.png";